module.exports = __webpack_public_path__ + "static/media/skila-bg_img-01-4-nad_600px_width-0_1.62a54a24.png";